import React, { useState, useRef, useEffect, ChangeEvent, FC } from "react"; // Replace with your actual import path
import { styled } from "styled-components";
import SearchIcon from "../../../../../images/common/search-charcoal-grey.svg";
import {
  FlexContainer,
  FooterOption,
  IStyleProps,
  theme,
} from "@mindmemobile/mm-shared-global";

const { text } = theme.palette;
const DropdownOption = styled.div`
  max-height: 130px;
  overflow-y: auto;
  cursor: pointer;
  width: 400px;
  /* li {
        list-style-type: none;
        font-weight: 400;
        color: ${text.main};
        line-height: 25px;
        cursor: pointer;
    }
    label {
        cursor: pointer;
    } */
  &::-webkit-scrollbar {
    width: 0.4em;
    height: 0.4em;
    background: rgba(21, 40, 55, 0.1);
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    outline: 1px solid #ddd;
    background-color: rgba(21, 40, 55, 0.3);
    border-radius: 10px;
  }

  li,
  .dropdown-option > div {
    &:hover {
      /* background-color: #9e9e9e26; */
      background-color: #f8f8f8;
      cursor: pointer;
    }
  }
`;
const SearchSelectWrapper = styled.div<IStyleProps>`
  display: flex;
  // align-items: center;
  position: relative;
  flex-direction: column;
  box-shadow: 0px 0px 1px #9bc9ff;
  border: 1px solid #9bc9ff;
  border-radius: 4px;
  .search-select-input {
    border: ${(props) =>
      props.hasError ? "1px solid red" : "1px solid #9BC9FF"};
    border-radius: ${(props) =>
      props.showOptions ? "4px 4px 0px 0px" : "4px"};
    border-bottom: ${(props) =>
      props.showOptions ? "none" : "1px solid #9BC9FF"};
    width: 393px;
    position: relative;
    img {
      height: 18px !important;
      width: 18px !important;
      margin-left: 10px;
      &.clear-search {
        position: absolute;
        top: 0px;
        right: 0px;
        transform: translate(-13px, 8px);
        cursor: pointer;
      }
    }
    input {
      padding: 12px 45px 12px 5px;
      border: none;
      height: 36px;
      color: #555;
      font-size: 14px;
      font-weight: 600;
      &::placeholder {
        color: #aaa;
      }
      &:focus {
        outline: none;
      }
    }
  }
  .options-menu {
    background: #fff;
    border: 1px solid #9bc9ff;
    border-top: 1px solid #aaa;
    padding: 2px;
    width: 393px;
    .searchable-dropdown-input {
      padding-left: 14px;
    }
    .dropdown-option {
      /* padding: 0px 10px; */
    }
    .search-sub-label {
      font-size: 11px;
      font-weight: 400;
      color: #aaa;
    }
    .search-dpdn-label {
      font-size: 14px;
      font-weight: 400;
      color: #555;
    }
  }
`;
interface SearchSelectOption {
  label: string;
  value: string | number;
  prices?: number;
}

interface SearchSelectInputProps {
  options: SearchSelectOption[];
  onChange: (option: SearchSelectOption) => void;
  placeholder?: string;
  customOption?: (option: any, searchValue?: string) => JSX.Element;
  selectedKey?: string | number;
  hasError?: boolean;
  errorMessage?: string;
  customFooter?: JSX.Element;
  // showPriceDropdown?: boolean;
}

const SearchSelectInput: FC<SearchSelectInputProps> = ({
  options,
  onChange,
  customOption,
  placeholder = "Search...",
  errorMessage,
  hasError = false,
  customFooter,
  // showPriceDropdown = false,
}) => {
  const [searchValue, setSearchValue] = useState<string>("");
  const [filteredOptions, setFilteredOptions] = useState<SearchSelectOption[]>(
    []
  );
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const lowercasedValue = searchValue.toLowerCase();
    const matchedOptions = options.filter((option) =>
      option.label.toLowerCase().includes(lowercasedValue)
    );
    setFilteredOptions(matchedOptions);
  }, [searchValue, options]);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target as Node)
    ) {
      setShowOptions(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleOptionClick = (option: SearchSelectOption) => {
    setSearchValue("");
    setShowOptions(false);
    onChange(option);
  };

  return (
    <SearchSelectWrapper
      ref={wrapperRef}
      hasError={hasError}
      showOptions={showOptions}
    >
      <FlexContainer fxLayout="column">
        <div>
          <FlexContainer
            spacing={5}
            alignItems="center"
            className="search-select-input"
          >
            <img src={SearchIcon} />
            <input
              type="text"
              value={searchValue}
              placeholder={placeholder}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                setSearchValue(e.target.value);
                setShowOptions(true);
              }}
              onFocus={() => setShowOptions(true)}
              className="styled-input search-select-input"
            />
            {/* <img src={SearchIcon} className="clear-search" /> */}{" "}
            {/* donot delete this line */}
            {hasError && errorMessage && (
              <p className="error-message">{errorMessage}</p>
            )}
          </FlexContainer>
        </div>
      </FlexContainer>

      {showOptions && filteredOptions.length > 0 && (
        <DropdownOption className="options-menu">
          {filteredOptions.map((option) => (
            <FlexContainer
              key={option.value}
              padding="0px"
              justifyContent="space-between"
              alignItems="center"
              onClick={() => handleOptionClick(option)}
              className="dropdown-option"
            >
              {customOption ? (
                customOption(option, searchValue)
              ) : (
                <>
                  <span>{searchValue && option.label}</span>
                </>
              )}
            </FlexContainer>
          ))}
        </DropdownOption>
      )}
      {showOptions && customFooter && (
        <FooterOption>{customFooter}</FooterOption>
      )}
    </SearchSelectWrapper>
  );
};

export default SearchSelectInput;
